import React from 'react';
import { TooltipLazy } from '../../tooltip-lazy/tooltip-lazy';
/*
      we want to use this component in SSR, so load tooltip component only
      after user hovers to avoid hydration issues
  */
export const PlaceholderTooltip = ({ className, isEnabled, tooltip, children }) => {
    const [isTooltipUsed, setIsTooltipUsed] = React.useState(false);
    return isTooltipUsed ? (React.createElement(TooltipLazy, { className: className, content: tooltip, disabled: !isEnabled, showDelay: 400, minWidth: 400, placement: "top-start", appendTo: "window", flip: true }, children)) : (React.createElement("div", { className: className, onMouseOver: () => setIsTooltipUsed(true) }, children));
};
//# sourceMappingURL=placeholder-tooltip.js.map